module.exports = __webpack_public_path__ + "media/images/icon-login-apple@3x-10260b7f3261dacdd0e3895fd8bb1761.png";